module.exports = __webpack_public_path__ + "static/img/通用版.479219f6.webp";